"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Functions {
    /**
     * @param func The function to debounce
     * @param wait The amount of milliseconds to wait before the same function is called again
     * @param immediate Should the function be called at the start or only at the end of the `wait` period
     */
    static debounce(func, wait, immediate = false) {
        let timeout = null;
        return function debounceHandler(...args) {
            const later = () => {
                timeout = null;
                if (immediate === false) {
                    // call at the end of the wait
                    func.apply(this, args);
                }
            };
            const callNow = immediate && timeout === null;
            if (timeout !== null) {
                window.clearTimeout(timeout);
            }
            timeout = window.setTimeout(later, wait);
            if (callNow) {
                // call the function at the start of the wait
                func.apply(this, args);
            }
        };
    }
}
exports.default = Functions;
//# sourceMappingURL=Functions.js.map